export function buildRendererLabel({ rendererName, rendererVersion }) {
  const rendererDetails = []

  if (rendererName) {
    rendererDetails.push(rendererName)
  }

  if (rendererVersion) {
    rendererDetails.push(rendererVersion)
  }

  if (!rendererDetails.length) {
    return null
  }

  return `Renderer: ${rendererDetails.join(' | ')}`
}
